/**
 * API配置文件
 * 包含API路径、重试策略和其他静态配置
 */

import { isDevelopment } from './utils';

// API 路径配置
export const API_PATHS = {
  // 主API路径 - 开发环境使用完整的后端API URL，生产环境使用环境变量配置
  // 由于Parcel不支持setupProxy.js，因此开发环境直接使用完整URL
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL || (isDevelopment() ? 'http://localhost:5001/api/v1' : '/api/v1'),

  // API端点
  PROXY: {
    MODEL: '/proxy/model',
    MODEL_STREAM: '/proxy/model/stream' // 新增流式API端点
  },

  AUTH: {
    SEND_CODE: '/auth/send-code',
    REGISTER: '/auth/register',
    REGISTER_PASSWORD: '/auth/register-with-password',
    LOGIN: '/auth/login',
    LOGIN_PASSWORD: '/auth/login-with-password',
    CHANGE_PASSWORD: '/auth/change-password',
    RESET_PASSWORD: '/auth/reset-password',
    EMAIL_WHITELIST: '/auth/email-whitelist'
  },

  USER: {
    CREDITS: '/user/credits',
    RECHARGE: '/user/recharge'
  },

  // 新增模式配置相关API路径
  MODE: {
    GET_PUBLIC_CONFIGS: '/public/mode-configs', // 公开获取可见模式配置
    GET_PUBLIC_CONFIG: (mode) => `/public/mode-configs/${mode}`, // 公开获取指定模式的可见配置
  },

  CHECKIN: {
    STATUS: '/checkin/status',
    DO: '/checkin/do',
    CONFIG_PUBLIC: '/checkin/config/public',
  },

  SKIN: {
    GET_ACTIVE: '/skins/active',
    RABBIT_STATUS: '/skins/rabbit/status',
    RABBIT_CATCH: '/skins/rabbit/catch',
    FLOWER_STATUS: '/skins/flower/status',
    FLOWER_TRIBUTE: '/skins/flower/tribute',
  },

  // TTS 语音合成公开配置
  TTS: {
    GET_PUBLIC_CONFIG: '/public/tts-config',
  },

  // BGM 背景音乐公开配置
  BGM: {
    GET_PUBLIC_CONFIG: '/public/bgm-config',
  }
};

// API 请求重试配置
export const RETRY_CONFIG = {
  maxRetries: 3,
  baseDelay: 1000, // 1秒基础延迟
  maxDelay: 10000, // 最大延迟10秒
  backoffMultiplier: 2 // 指数退避倍数
};

// API 请求限流配置
export const RATE_LIMIT_CONFIG = {
  maxConcurrentRequests: 2000, // 最大并发请求数
  minRequestInterval: 2000 // 请求之间的最小间隔（毫秒）
};

// 本地存储键名
export const STORAGE_KEYS = {
  CURRENT_USER: 'hammerath_current_user',
  MODE_CONFIGS: 'hammerath_mode_configs', // 存储模式配置的键名
  ACTIVE_SKIN: 'hammerath_active_skin', // 存储当前生效皮肤的键名
  TTS_PUBLIC_CONFIG: 'hammerath_tts_public_config', // 存储公开TTS配置的键名
  BGM_PUBLIC_CONFIG: 'hammerath_bgm_public_config' // 存储公开BGM配置的键名
};

// 积分与支付相关配置
export const CREDITS_CONFIG = {
  FREE_CREDITS: 30, // 新用户免费获得次数
  CREDITS_PER_PAYMENT: 600, // 每100元可获得的积分数
  PAYMENT_AMOUNT: 100 // 每次充值金额
};

export default {
  API_PATHS,
  RETRY_CONFIG,
  RATE_LIMIT_CONFIG,
  STORAGE_KEYS,
  CREDITS_CONFIG
};
